import { InjectionToken } from '@angular/core';

import { AccaBoostToken, CriteriaType } from '../reward-tokens/reward-tokens.model';

export enum NotificationType {
    Ladder = 'Ladder',
    Error = 'Error',
    MaxReward = 'MaxReward',
    OneSelectionAway = 'OneSelectionAway',
}

export enum AccaBoostError {
    InvalidSport = 'InvalidSport',
    InvalidCompetition = 'InvalidCompetition',
    InvalidGameType = 'InvalidGameType',
    InvalidMarket = 'InvalidMarket',
    InvalidSlipType = 'InvalidSlipType',
    InvalidPickType = 'InvalidPickType',
    MinOdds = 'MinOdds',
    MinLegs = 'MinLegs',
    Expired = 'Expired',
    OtherTokenUsed = 'OtherTokenUsed',
}

export interface AccaBoostContext {
    token: AccaBoostToken | undefined;
    isSelected: boolean;
    isOneLegAway: boolean;
    picksCount: number;
    maxReward: boolean;
    validCombo: boolean;
}

export const ErrorsMap: Record<CriteriaType, AccaBoostError> = {
    [CriteriaType.Sports]: AccaBoostError.InvalidSport,
    [CriteriaType.Competitions]: AccaBoostError.InvalidCompetition,
    [CriteriaType.GameType]: AccaBoostError.InvalidGameType,
    [CriteriaType.Market]: AccaBoostError.InvalidMarket,
    [CriteriaType.SlipType]: AccaBoostError.InvalidSlipType,
    [CriteriaType.MinOdds]: AccaBoostError.MinOdds,
    [CriteriaType.ParticipantBetSelected]: AccaBoostError.InvalidSport,
    [CriteriaType.BetBuilderBetSelected]: AccaBoostError.InvalidPickType,
    [CriteriaType.ExpiryDate]: AccaBoostError.Expired,
    [CriteriaType.DayOfWeek]: AccaBoostError.Expired,
} as Record<CriteriaType, AccaBoostError>;

export interface INotification {
    type: NotificationType;
    duration?: number;
}
type LadderNotificationParams = Pick<LadderNotification, 'token' | 'tokenSwitched' | 'picksCount' | 'duration'>;

export class LadderNotification implements INotification {
    type = NotificationType.Ladder;
    token: AccaBoostToken;
    tokenSwitched: boolean;
    picksCount: number;
    duration: number;

    constructor({ token, tokenSwitched, picksCount, duration }: LadderNotificationParams) {
        this.token = token;
        this.tokenSwitched = tokenSwitched;
        this.picksCount = picksCount;
        this.duration = duration;
    }
}

export class ErrorNotification implements INotification {
    type = NotificationType.Error;
    constructor(
        public token: AccaBoostToken,
        public error: AccaBoostError,
        public duration: number,
        public isTrendingAccasSelected?: boolean,
    ) {}
}

export class MaxRewardNotification implements INotification {
    type = NotificationType.MaxReward;
    constructor(
        public token: AccaBoostToken,
        public duration: number,
        public picksCount: number,
    ) {}
}

export class OneSelectionAwayNotification implements INotification {
    type = NotificationType.OneSelectionAway;
    constructor(
        public token: AccaBoostToken,
        public duration: number,
    ) {}
}

export function isLadderNotification(current: INotification | undefined): current is LadderNotification {
    return current instanceof LadderNotification;
}

export enum AccaBoostLayout {
    Desktop,
    Mobile,
}

export interface AccaBoostLayoutProvider {
    getLayout(): AccaBoostLayout;
    readonly isDesktop: boolean;
}

export const ACCA_BOOST_LAYOUT_PROVIDER = new InjectionToken<AccaBoostLayoutProvider>('Acca Boost layout provider.');
